import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CsvHeaderMatchDialogComponent } from './csv-header-match/csv-header-match.component';
import { FormsModule } from '@angular/forms';
import { CsvImporterComponent } from './csv-importer.component';
@NgModule({
  declarations: [FileUploadDialogComponent, CsvHeaderMatchDialogComponent, CsvImporterComponent],
  imports: [CommonModule, FormsModule, MatDialogModule],
  exports: [FileUploadDialogComponent, CsvHeaderMatchDialogComponent, CsvImporterComponent]
})
export class CsvImporterModule {}
